import { render, staticRenderFns } from "./JobSearch.vue?vue&type=template&id=688b90a8&scoped=true"
import script from "./JobSearch.vue?vue&type=script&lang=js"
export * from "./JobSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688b90a8",
  null
  
)

export default component.exports